import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import DunesDirtReport from './DunesDirtReport';
import SpecialEvents from './SpecialEvents';
import GDRTeam from './GDRTeam';
import ParkRules from './ParkRules';
import RiderTraining from './RiderTraining';
import SummerCamps from './SummerCamps';
import reportWebVitals from './reportWebVitals';
import BikeRentals from './BikeRentals';
import ContactUs from './ContactUs';
import Cabins from './Cabins';
import Store from './Store';
import Memberships from './Memberships';
import GiftCertificates from './GiftCertificates';
import ScrollToTop from './components/ScrollToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/dunes-dirt-report" element={<DunesDirtReport />} />
        <Route path="/special-events" element={<SpecialEvents />} />
        <Route path="/gdr" element={<GDRTeam />} />
        <Route path="/park-rules" element={<ParkRules />} />
        <Route path="/rider-training" element={<RiderTraining />} />
        <Route path="/bike-rentals" element={<BikeRentals />} />
        <Route path="/summer-camps" element={<SummerCamps />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/cabins" element={<Cabins />} />
        <Route path="/store" element={<Store />} />
        <Route path="/memberships" element={<Memberships />} />
        <Route path="/gift-certificates" element={<GiftCertificates />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
